// // BASE SET
export const SET_BASE_MODEL = 'setBaseModel'
export const SET_SERIES = 'setSeries'
export const SET_DOMINANT_ARM = 'setDominantArm'
export const SET_SIZE = 'setSize'
export const SET_LININGS = 'setLinings'
export const SET_WEB_PARTS = 'setWebParts'
export const SET_YELL_STORY_LABEL = 'setYellStoryLabel'
export const SET_YSR_ORIGINAL_EMBROIDERY = 'setYsrOriginalEmbroidery'
export const SET_YSR_DIRECT_LOGO_1_POSITION = 'ysrDirectLogo1Position'
export const SET_YSR_DIRECT_LOGO_1_MAIN_COLOR = 'ysrDirectLogo1MainColor'
export const SET_YSR_DIRECT_LOGO_1_EDGE_COLOR = 'ysrDirectLogo1EdgeColor'
export const SET_YSR_DIRECT_LOGO_2_POSITION = 'ysrDirectLogo2Position'
export const SET_YSR_DIRECT_LOGO_2_COLOR = 'ysrDirectLogo1Co2or'
export const SET_FINGER_GUARD_TYPE = 'setFingerGuardType'
export const SET_LEATHER_INTEGRATED_INDEX = 'setLeatherIntegratedIndex'
export const SET_LEATHER_INTEGRATED_MIDDLE = 'setLeatherIntegratedMiddle'
export const SET_LEATHER_INTEGRATED_RING = 'setLeatherIntegratedRing'
export const SET_MATERIAL_PACK = 'setMaterialPack'

// // COLOR
export const SET_SELECTED_PARTS = 'setSelectedParts'
export const SET_ALL_LEATHER_COLOR = 'setAllLeatherColor'
export const SET_LEATHER_COLOR = 'setLeatherColor'
export const SET_LACE_COLOR = 'setLaceColor'
export const SET_EDGE_COLOR = 'setEdgeColor'
export const SET_STITCH_COLOR = 'setStitchColor'
export const SET_WEB_COLOR = 'setWebColor'
export const SET_WEB_COLOR_2 = 'setWebColor2'
export const SET_THUMB_HOOK = 'setThumbHook'
export const SET_LITTLE_HOOK = 'setLittleHook'
export const SET_LIST_BELT_COLOR = 'setListBeltColor'
export const SET_INDEX_COVER_COLOR = 'setIndexCoverColor'
export const SET_HAMIDASHI = 'setHamidashi'

export const SET_THUMB_OUT_COLOR = 'thumbOut'
export const SET_THUMB_WEB_COLOR = 'thumbWeb'
export const SET_INDEX_WEB_COLOR = 'indexWeb'
export const SET_INDEX_MIDDLE_COLOR = 'indexMiddle'
export const SET_MIDDLE_INDEX_COLOR = 'middleIndex'
export const SET_MIDDLE_RING_COLOR = 'middleRing'
export const SET_RING_MIDDLE_COLOR = 'ringMiddle'
export const SET_RING_LITTLE_COLOR = 'ringLittle'

export const SET_LITTLE_RING_COLOR = 'littleRing'
export const SET_LITTLE_OUT_COLOR = 'littleOut'

// // EMBROIDERY
export const SET_EMBROIDERIES = 'setEmbroideries'
export const ADD_EMBROIDERY = 'addEmbroideries'
export const REMOVE_EMBROIDERY = 'RemoveEmbroideries'

// // ALL
export const SET_PERSONAL = 'setPersonal'
export const SET_FIGURE_PANEL_NUMBER = 'setFigurePanelNumber'

// これはカラーだけに関するconstantsなので、別ファイルにあるべき
export const DISPATCHER = {
  series: SET_SERIES,
  dominantArm: SET_DOMINANT_ARM,
  size: SET_SIZE,
  fingerGuardType: SET_FINGER_GUARD_TYPE,
  materialPack: SET_MATERIAL_PACK,
  webParts: SET_WEB_PARTS,
  parts: SET_SELECTED_PARTS,
  all: SET_ALL_LEATHER_COLOR,
  catchFace: SET_LEATHER_COLOR,
  web: SET_WEB_COLOR,
  web2: SET_WEB_COLOR_2,
  edge: SET_EDGE_COLOR,
  thumbHook: SET_THUMB_HOOK,
  littleHook: SET_LITTLE_HOOK,
  lace: SET_LACE_COLOR,
  indexCover: SET_INDEX_COVER_COLOR,
  stitch: SET_STITCH_COLOR,
  linings: SET_LININGS,
  hamidashi: SET_HAMIDASHI,
  ysrLabel: SET_YELL_STORY_LABEL,
  ysrOriginalEmbroidery: SET_YSR_ORIGINAL_EMBROIDERY,
  ysrDirectLogo1Position: SET_YSR_DIRECT_LOGO_1_POSITION,
  ysrDirectLogo1MainColor: SET_YSR_DIRECT_LOGO_1_MAIN_COLOR,
  ysrDirectLogo1EdgeColor: SET_YSR_DIRECT_LOGO_1_EDGE_COLOR,
  ysrDirectLogo2Position: SET_YSR_DIRECT_LOGO_2_POSITION,
  ysrDirectLogo2Color: SET_YSR_DIRECT_LOGO_2_COLOR,

  // 内野手用グラブここから
  thumbOut: SET_THUMB_OUT_COLOR,
  thumbWeb: SET_THUMB_WEB_COLOR,
  indexWeb: SET_INDEX_WEB_COLOR,
  indexMiddle: SET_INDEX_MIDDLE_COLOR,
  middleIndex: SET_MIDDLE_INDEX_COLOR,
  middleRing: SET_MIDDLE_RING_COLOR,
  ringMiddle: SET_RING_MIDDLE_COLOR,
  ringLittle: SET_RING_LITTLE_COLOR,
  littleRing: SET_LITTLE_RING_COLOR,
  littleOut: SET_LITTLE_OUT_COLOR,
  listBelt: SET_LIST_BELT_COLOR,
  leatherIntegratedIndex: SET_LEATHER_INTEGRATED_INDEX,
  leatherIntegratedMiddle: SET_LEATHER_INTEGRATED_MIDDLE,
  leatherIntegratedRing: SET_LEATHER_INTEGRATED_RING
}
